import React from 'react';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLayout } from '../../contexts/LayoutContext';

/*
  MobileMenuButton: the nav-drawer toggle hosted inside a page header on mobile
  (md-down). Reads the toggle from LayoutContext so headers don't need to thread
  the handler through props. Renders nothing when no toggle is available (e.g.
  outside the app shell) or on md+ where the sidebar is permanent.
*/
export default function MobileMenuButton({ color = 'inherit', sx }) {
  const { onMenuClick } = useLayout();
  if (!onMenuClick) return null;
  return (
    <IconButton
      onClick={onMenuClick}
      aria-label="open navigation"
      edge="start"
      sx={{ display: { md: 'none' }, color, flexShrink: 0, mr: 0.25, ...sx }}
    >
      <MenuIcon />
    </IconButton>
  );
}
